// Per-document settings live in the workbook (Office.context.document.settings).
// They roam with the file, so each .xlsx has its own chat thread.

export function getDocSetting<T>(key: string): T | null {
  const v = Office.context.document.settings.get(key);
  return v === undefined || v === null ? null : (v as T);
}

export function setDocSetting<T>(key: string, value: T | null): Promise<void> {
  if (value === null) Office.context.document.settings.remove(key);
  else Office.context.document.settings.set(key, value);
  return new Promise((resolve, reject) => {
    Office.context.document.settings.saveAsync((r) => {
      if (r.status === Office.AsyncResultStatus.Succeeded) resolve();
      else reject(r.error);
    });
  });
}
